import React from 'react';
import {
	HubStatsWrapper,
	HubStatsTitle,
	HubStatsCount
} from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import {
	HubStatsProgressBar,
	HubStatsProgressBarWithCount
} from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsProgressBar";
import {
	HubStatsLegend
} from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsLegend";
import { useSelector } from "react-redux";
import { getHubStats } from "apps/BWW_PLAY_HUB/modules/selectors/hub_stats";
import { orderBy } from "lodash";
import { getProfileValue, getPercent, EnumStatsType, IRewardPoints } from "apps/BWW_PLAY_HUB/components/HubStats/utils";


export const RewardPoints: React.FC = () => {
	const { pp, trivia, reward_points } = useSelector(getHubStats);
	const pp_reward_points = pp.reward_points;
	const trivia_reward_points = trivia.reward_points;
	const total_reward_points = pp_reward_points + trivia_reward_points;
	const has_reward_points = Boolean(total_reward_points);

	if (!reward_points) {
		return null;
	}

	const reward_points_arr: IRewardPoints[] = [
		{
			type   : EnumStatsType.pp,
			value  : pp_reward_points,
			percent: getPercent(pp_reward_points, total_reward_points)
		},
		// {
		// 	type: EnumStatsType.trivia,
		// 	value: trivia_reward_points,
		// 	percent: getPercent(trivia_reward_points, total_reward_points),
		// },
	];

	const order_by_reward_points = orderBy(reward_points_arr, ['value'], ['desc']);

	return (
		<HubStatsWrapper>
			<HubStatsTitle>Total reward points won</HubStatsTitle>
			<HubStatsProgressBarWithCount>
				<HubStatsCount>{ getProfileValue(reward_points) }</HubStatsCount>
				{ has_reward_points && <HubStatsProgressBar items={order_by_reward_points} /> }
			</HubStatsProgressBarWithCount>
			{ has_reward_points && <HubStatsLegend items={order_by_reward_points} /> }
		</HubStatsWrapper>
	);
};
